import * as angular from 'angular';
import { debounce, getService } from 'data/function';
import { CloseEditorIfOpenedEvent, GLOBAL_ACTIONS } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/BuilderController';
import { BuilderFeatures } from '../../BuilderFeatures';
import { CustomActionIAction } from '../../historyActions/CustomActionIAction';
import { ConditionViewModel } from '../../models/viewModels/ConditionViewModel';
import { ActionContentService } from '../../services/ActionContentService';
import { BuilderStore } from '../../store/BuilderStore';
export const ACTION_UNDO_REDO_CHANGES = 'actions_undoredo_changes';
export const conditionFromAction = 'condition_from_action';
export class ActionController {
    static $inject = ['close', 'action', '$onStateChanged', 'UndoRedoService', 'state', '$rootScope'];
    constructor(close, action, $onStateChanged, UndoRedoService, state, $rootScope, // Don't use access modifier to not affect other abstractions
    $scope, typeOfAction, onOpenSchemaEditor, onActionBlur) {
        this.close = close;
        this.action = action;
        this.$onStateChanged = $onStateChanged;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.$scope = $scope;
        this.typeOfAction = typeOfAction;
        this.onOpenSchemaEditor = onOpenSchemaEditor;
        this.onActionBlur = onActionBlur;
        this.debouncedHandleCustomActionChanges = debounce(this.handleCustomActionChanges, 1500);
        this.segmentPayload = {};
        this.isBuilderUndoRedoActionEnabled = false;
        this.isDeepChange = true;
        this.nameOftheBlock = '';
        this.isAiAgentState = false;
        this.isValidActionName = true;
        this.isUniqueTitle = true;
        this.actionErrorList = [];
        this.builderStore = BuilderStore.getInstance();
        this.ActionContentService = ActionContentService.getInstance();
        this.$rootScope = $rootScope;
        if (this.action.settings == undefined) {
            this.action.settings = this.create();
        }
        this.BuilderSegmentService = getService('BuilderSegmentService');
        this.copy();
        this.initBuilderUndoRedoActionEnabled();
    }
    $onInit() {
        this.$rootScope.$broadcast(conditionFromAction);
    }
    async initBuilderUndoRedoActionEnabled() {
        this.isBuilderUndoRedoActionEnabled = await BuilderFeatures.builderUndoRedoActionEnabled();
        this.timeout = await getService('$timeout');
        if (this.isBuilderUndoRedoActionEnabled) {
            this.translate = await getService('$translate');
            this.nameOftheBlock = await this.translate('builder-configurations.globalActions.title');
            this.initializeProxy();
        }
    }
    handleCustomActionChanges() {
        if (angular.equals(this.action, this.oldCustomAction) && (this.action.$title === this.oldCustomAction.$title)) {
            return;
        }
        const currentActionID = this.action.$id;
        const customAction = new CustomActionIAction({
            execute: async (data) => {
                try {
                    const action = this.getAction(currentActionID, data, false);
                    this.createTracking(action, false);
                    this.$rootScope.$emit(ACTION_UNDO_REDO_CHANGES);
                    await this.$onStateChanged(action);
                }
                catch (e) {
                    console.error(e);
                }
            },
            undo: async (data) => {
                try {
                    const action = this.getAction(currentActionID, data, true);
                    this.createTracking(action, true);
                    this.$rootScope.$emit(ACTION_UNDO_REDO_CHANGES);
                    await this.$onStateChanged(action);
                }
                catch (e) {
                    console.error(e);
                }
            },
            data: {
                after: angular.copy(this.action),
                before: angular.copy(this.oldCustomAction),
                currentState: this.state,
                state: {
                    id: this.state.id === GLOBAL_ACTIONS ? this.nameOftheBlock : this.state.id,
                    //covering cases where GlobalActions or actions should be accepted
                    $title: [this.state.$title, this.state.id].includes(GLOBAL_ACTIONS) ? this.nameOftheBlock : this.state.$title || this.state.id,
                },
            },
        });
        this.oldCustomAction = undefined;
        this.UndoRedoService.add(customAction);
        this.trackBlockActionEdited(this.typeOfAction, this.action.type, this.state.id === GLOBAL_ACTIONS);
    }
    getAction(currentActionID, data, isUndoAction) {
        const action = this.state.$enteringCustomActions.concat(this.state.$leavingCustomActions).find(a => a.$id === currentActionID);
        let contentActions;
        if (!action) {
            contentActions = this.state.$contentActions.find(item => item.action.$id === currentActionID);
            if (!contentActions) {
                return;
            }
        }
        this.isDeepChange = false;
        if (isUndoAction) {
            action.$title = data.before?.$title;
            action.settings = data.before?.settings;
            action.conditions = data.before?.conditions;
        }
        else {
            action.$title = data.after?.$title;
            action.settings = data.after?.settings;
            action.conditions = data.after?.conditions;
        }
        return action;
    }
    createTracking(action, isUndoTracking) {
        if (!action) {
            return;
        }
        this.segmentPayload = {
            botName: this.state.$title,
            blockID: action.$id || undefined,
            conditionType: action.type,
        };
        if (!isUndoTracking) {
            this.trackBlockActionRedo(this.segmentPayload, true);
        }
        else {
            this.trackBlockActionUndo(this.segmentPayload, true);
        }
    }
    async save() {
        if (this.isDeepChange === false) {
            this.isDeepChange = true;
        }
        if (!this.isBuilderUndoRedoActionEnabled) {
            this.action.settings = { ...this.settings, ...this.action.settings };
        }
        await this.$onStateChanged(this.action);
    }
    trackBlockActionEdited(ActionTime, ActionType, isGlobalAction) {
        this.BuilderSegmentService.trackBlockActionEdited({
            ActionTime,
            ActionType,
            BlockID: this.state.id,
        }, true, isGlobalAction);
    }
    async saveAndClose() {
        await this.save();
        this.handleClose();
    }
    handleClose() {
        this.$rootScope.$broadcast(CloseEditorIfOpenedEvent);
        this.close();
    }
    cancel() {
        this.copy();
        this.handleClose();
    }
    copy() {
        this.$title = this.action.$title;
    }
    createCondition() {
        const condition = new ConditionViewModel();
        this.action.conditions = this.action.conditions.concat(condition);
        this.save();
    }
    removeCondition(index) {
        this.action.conditions.splice(index, 1);
        this.save();
    }
    onDescriptionChanges(description) {
        if (this.action?.$description !== null && this.action?.$description !== undefined) {
            this.action.$description = description;
            this.save();
        }
    }
    openSchemaEditor() {
        this.onOpenSchemaEditor(this.action);
    }
    initializeProxy() {
        this.$scope.$watch('$ctrl.action.$title', (newValue, oldValue) => {
            if (this.isDeepChange === false) {
                return;
            }
            if (this.oldCustomAction === undefined) {
                this.oldCustomAction = { ...angular.copy(this.action), $title: oldValue };
            }
            this.debouncedHandleCustomActionChanges();
        });
        this.$scope.$watch('$ctrl.action', (newValue, oldValue) => {
            if (this.isDeepChange === false) {
                return;
            }
            if (this.oldCustomAction === undefined) {
                this.oldCustomAction = angular.copy(oldValue);
            }
            this.ActionContentService.setIsEditingActionContent(true);
            this.debouncedHandleCustomActionChanges();
        }, true);
    }
    trackBlockActionUndo(segmentPayload, success) {
        this.BuilderSegmentService.trackBlockActionUndo(segmentPayload, success);
    }
    trackBlockActionRedo(segmentPayload, success) {
        this.BuilderSegmentService.trackBlockActionRedo(segmentPayload, success);
    }
}
ActionController.$inject = ['close', 'action', '$onStateChanged', 'UndoRedoService', 'state', '$rootScope', '$scope', 'typeOfAction', 'onOpenSchemaEditor', 'onActionBlur'];
